<div class="p-2 light-blue-header d-flex flex-row justify-content-between modal-header">
    <div class="p-2 modal-title"><h5>Building Scout</h5></div>
    <button class="p-0 m-0 btn" style="line-height: .8" (click)="onCancel()" aria-label="Close">
        <i class="fa fa-window-close"></i>
    </button>
</div>

<div class="container-fluid busy-overlay-parent p-2" [ngClass]="isLoading?'disabled':''">
    <div *ngIf="isLoading || bProcessing" class="font-weight-bold busy-overlay">
        <i class="fa fa-spinner fa-spin"></i>
    </div>
    <form #scoutForm="ngForm">
        <table class="edit-table table table-striped table-condensed">
            <thead>
            </thead>
            <tbody>
                <tr>
                    <th>Scheduler</th>
                    <td>
                        <select name="scheduler" [(ngModel)]="tmpScout.assignments.scheduleUserId">
                            <option *ngFor="let user of schedulerUsers" [ngValue]="user._id">{{user.firstName + ' ' + user.lastName}}</option>
                        </select>
                    </td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="errorMsg" class="alert alert-danger">{{errorMsg}}</div>
    </form>
</div>

<div class="modal-footer">
    <button [disabled]="isLoading || !scoutForm.dirty || scoutForm.invalid" (click)="onSave();onYes()" class="btn btn-primary">Save</button>
    <button (click)="onCancel()" class="btn btn-secondary">Cancel</button>
</div>
